const translations = {
  en: {
    ...require('./en/general.json'),
    seo: require('./en/seo.json'),
    auth: require('./en/auth.json'),
    settings: require('./en/settings.json'),
    invitation: require('./en/invitation.json'),
    gui: require('./en/gui.json'),
    userSubscribition: require('./en/userSubscribition.json'),
    promocode: require('./en/promocode.json'),
    admin: {
      navigation: require('./en/admin/navigation.json'),
      editor: require('./en/admin/editor.json'),
      workingHours: require('./en/admin/workingHours.json'),
      lessonsStats: require('./en/admin/lessonsStats.json'),
      userStats: require('./en/admin/userStats.json'),
      paymentsStats: require('./en/admin/paymentsStats.json'),
      promocodes: require('./en/admin/promocodes.json'),
      subscription: require('./en/admin/subscription.json'),
      courses: require('./en/admin/courses.json'),
      playing: require('./en/admin/playing.json'),
      mail: require('./en/admin/mail.json'),
      chat: require('./en/admin/chat.json'),
      attempts: require('./en/admin/attempts.json'),
      invitations: require('./en/admin/invitations.json'),
      salary: require('./en/admin/salary.json'),
    },
    register: require('./en/register.json'),
    shop: require('./en/shop.json'),
    greeting: require('./en/greeting.json'),
    nav: require('./en/nav.json'),
    learnProcess: require('./en/learnProcess.json'),
    offer: require('./en/offer.json'),
    static: require('./en/static.json'),
    main: require('./en/main.json'),
    onboarding: require('./en/onboarding.json'),
    homework: require('./en/homework.json'),
  },
  ru: {
    ...require('./ru/general.json'),
    seo: require('./ru/seo.json'),
    auth: require('./ru/auth.json'),
    settings: require('./ru/settings.json'),
    gui: require('./ru/gui.json'),
    invitation: require('./ru/invitation.json'),
    userSubscribition: require('./ru/userSubscribition.json'),
    promocode: require('./ru/promocode.json'),
    admin: {
      navigation: require('./ru/admin/navigation.json'),
      editor: require('./ru/admin/editor.json'),
      workingHours: require('./ru/admin/workingHours.json'),
      lessonsStats: require('./ru/admin/lessonsStats.json'),
      userStats: require('./ru/admin/userStats.json'),
      paymentsStats: require('./ru/admin/paymentsStats.json'),
      promocodes: require('./ru/admin/promocodes.json'),
      subscription: require('./ru/admin/subscription.json'),
      courses: require('./ru/admin/courses.json'),
      playing: require('./ru/admin/playing.json'),
      mail: require('./ru/admin/mail.json'),
      chat: require('./ru/admin/chat.json'),
      attempts: require('./ru/admin/attempts.json'),
      invitations: require('./ru/admin/invitations.json'),
      salary: require('./ru/admin/salary.json'),
    },
    register: require('./ru/register.json'),
    shop: require('./ru/shop.json'),
    greeting: require('./ru/greeting.json'),
    nav: require('./ru/nav.json'),
    learnProcess: require('./ru/learnProcess.json'),
    offer: require('./ru/offer.json'),
    static: require('./ru/static.json'),
    main: require('./ru/main.json'),
    onboarding: require('./ru/onboarding.json'),
    homework: require('./ru/homework.json'),
  },
};

export default translations;
